import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth-service/auth-service.service';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { BaseNode } from '../../ui/Node/BaseNode';

export enum IMPORT_TYPE { EVPRM = "import", ACKEVPRM = "importack" };

@Injectable({
  providedIn: 'root'
})
export class WebtraderService {

  public loading = new BehaviorSubject<boolean>(false);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private injector: Injector) { }


  filter(node: BaseNode, entity: string, criteria: string, pageNumber: number, or: boolean, filter?: string): Observable<{}> {

    this.loading.next(true);
    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });

    let params = new HttpParams().set('c', criteria);
    params = params.append('p', pageNumber);
    params = params.append('s', 50);
    params = params.append('f', 50);
    params = params.append('or', or);

    return this.httpClient
      .get(`${environment.apiUrl}/api/webtrader/search/${entity}`, {
        headers: headers, params: params
      })
      .pipe(
        map((resp) => {
          const result = resp as [];
          this.loading.next(false);
          return { node, result };
        })
      );
  }

  filterToExcel(entity: string, criteria: string, pageNumber: number, or: boolean, isExport: boolean): Observable<Blob> {

    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });

    let params = new HttpParams().set('c', criteria);
    params = params.append('p', pageNumber);
    if (!isExport) {
      params = params.append('s', 0);
      params = params.append('f', 1000000);
    }
    params = params.append('or', or);


    return this.httpClient.get(`${environment.apiUrl}/api/webtrader/search/excel/${entity}`, { headers: headers, params: params, responseType: 'blob' });
  }

  exportResultsToExcel(entity: string, data: any): Observable<Blob> {

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken()
    });

    const formData = new FormData();
    formData.append("data", new Blob(
      [JSON.stringify(data)],
      { type: "application/json" }
    ));
    return this.httpClient.post(`${environment.apiUrl}/api/webtrader/export/excel/${entity}`, formData, { headers: headers, responseType: 'blob' });
  }

  getBulkUpdateMessages(path: string): Observable<any> {

    this.loading.next(true);
    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });


    let params = new HttpParams().set('path', path);

    return this.httpClient.get<any>(`${environment.apiUrl}/api/webtrader/bulkupdate`, { headers, params }).pipe(
      map((data) => data)
    );
  }

  getBulkUpdateContent(path: string): Observable<any> {

    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
      AuthSession: this.authService.getSessionToken(),
    });

    let params = new HttpParams().set('path', path);

    return this.httpClient.get<any>(`${environment.apiUrl}/api/webtrader/bulkupdate/xml`, { headers, params }).pipe(
      map((data) => data)
    );

  }

  import(file: File, type: IMPORT_TYPE): Observable<any> {

    this.loading.next(true);
    const formData: FormData = new FormData();
    this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Validating message structure...', life: environment.successElapsedTime });
    formData.append('file', file);
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.getAccessToken(),
      'AuthSession': this.authService.getSessionToken()
    });


    //Post
    return this.httpClient.post(environment.apiUrl + '/api/webtrader/' + type, formData, { headers: headers }).pipe(
      map((resp) => {
        const result = resp as [];
        if (result != null) {
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Message structure successfully validated', life: environment.successElapsedTime });
        } else {
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'XEVPRM contains error(s), invalid message structure', life: environment.errorElapsedTime });
        }
        this.loading.next(false);
        return result;
      })
    );


  }

}
